import { UseCaseInteractor } from '../../../kernel/use-case'
import { BaseClient } from '../domain/client'
import { UserRepository } from '../domain/user.repository'

export const changeUserClientUseCase: UseCaseInteractor<
  [userRepository: UserRepository],
  [userId: string, client: BaseClient],
  void
> =
  (userRepository: UserRepository) =>
  async (userId: string, client: BaseClient): Promise<void> => {
    return userRepository.changeUserClient(userId, client)
  }
